import html2canvas from "html2canvas"
import jsPDF from "jspdf"

export const onDownloadReportPdf = async (
  setLoading,
  reportRef,
  fileName = "Appointment_letter"
) => {
  if (!reportRef.current) return
  setLoading(true)

  try {
    const pages = reportRef.current.querySelectorAll(".a4-page")
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true,       // enables jsPDF's built-in deflate compression
    })

    const pdfWidth  = pdf.internal.pageSize.getWidth()   // 210mm
    const pdfHeight = pdf.internal.pageSize.getHeight()  // 297mm

    for (let i = 0; i < pages.length; i++) {
      const page = pages[i]

      // scale: 1.5 gives sharp text (150 DPI equivalent) at ~55% of scale:2's bitmap size
      // scale: 1.2 is acceptable if you still find files too large
      const canvas = await html2canvas(page, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: "#ffffff",
        logging: false,
        // render only what's visible — no need to scroll-capture
        windowWidth:  page.scrollWidth,
        windowHeight: page.scrollHeight,
      })

      // JPEG at quality 0.85 is ~10-15× smaller than PNG for document content
      // Raise to 0.92 for sharper images, lower to 0.75 to shrink further
      const imgData = canvas.toDataURL("image/jpeg", 0.85)

      const imgHeight = (canvas.height * pdfWidth) / canvas.width

      if (i !== 0) pdf.addPage()

      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdfWidth,
        Math.min(imgHeight, pdfHeight),
        undefined,          // alias — leave blank so jsPDF deduplicates identical images
        "FAST"              // FAST = deflate compression on the embedded image stream
      )

      // 🔑 Release the canvas from memory immediately after embedding
      // Without this, 35 canvases pile up in RAM and can crash the tab
      canvas.width  = 0
      canvas.height = 0
    }

    pdf.save(`${fileName}.pdf`)
  } catch (err) {
    console.error("PDF generation failed:", err)
  } finally {
    setLoading(false)
  }
}







// Centered

// import html2canvas from "html2canvas"
// import jsPDF from "jspdf"

// export const onDownloadReportPdf = async (
//     setLoading,
//     reportRef,
//     fileName = "Seo_Report"
// ) => {
//     if (!reportRef.current) return

//     setLoading(true)

//     const pages = reportRef.current.querySelectorAll(".report-page")

//     const pdf = new jsPDF("p", "mm", "a4")
//     const pdfWidth = pdf.internal.pageSize.getWidth()
//     const pdfHeight = pdf.internal.pageSize.getHeight()

//     for (let i = 0; i < pages.length; i++) {
//         const page = pages[i]

//         const canvas = await html2canvas(page, {
//             scale: 2,
//             useCORS: true,
//             backgroundColor: "#fff",
//         })

//         const imgData = canvas.toDataURL("image/png")

//         const imgWidth = pdfWidth
//         const imgHeight = (canvas.height * imgWidth) / canvas.width

//         // ✅ CENTER CONTENT VERTICALLY
//         const yOffset =
//             imgHeight < pdfHeight ? (pdfHeight - imgHeight) / 2 : 0

//         if (i !== 0) pdf.addPage()

//         pdf.addImage(
//             imgData,
//             "PNG",
//             0,
//             yOffset,
//             imgWidth,
//             Math.min(imgHeight, pdfHeight),
//         )
//     }

//     pdf.save(`${fileName}.pdf`)
//     setLoading(false)
// }





